<template>
  <div class="articlePage pageWhite pagePadding">
    <div class="paramWrap">
      <el-form :model="formData" class="formClass" label-width="120px" ref="form">
        <el-form-item label="档案提示">
          <quill-editor v-model="formData.archive" :options="editorOption"
                        @change="setHtml($event,'archive')"></quill-editor>
        </el-form-item>
        <el-form-item label="户口提示">
          <quill-editor v-model="formData.account" :options="editorOption"
                        @change="setHtml($event,'account')"></quill-editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toSave" :loading="isSubmit">保存修改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {quillEditor} from 'vue-quill-editor'

  export default {
    data () {
      return {
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote'],
              ['clean'],
              [{'color': []}, {'background': []}],
              [{'align': []}],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'indent': '-1'}, {'indent': '+1'}],
              [{'direction': 'rtl'}]
            ]
          },
          placeholder: '请输入'
        },
        isSubmit: false,
        formData: {
          'archive': '',
          'account': ''
        }
      }
    },
    created () {
      this.getParam()
    },
    methods: {
      setHtml ({editor, html}, key) {
        this['formData'][key] = html
      },
      getParam () {
        this.$api.getParam(res => {
          this.formData['archive'] = res['archivesTip']
          this.formData['account'] = res['householdTip']
        })
      },
      toSave () {
        this.$confirm('确认提交修改,是否继续?', '参数修改', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isSubmit = true
          this.$api.updateParam({archivesTip: this.formData['archive'], householdTip: this.formData['account']}, () => {
            this.$message.success('修改成功')
          }, () => {
            this.isSubmit = false
          })
        }).catch(() => {
        })
      }
    },
    components: {
      quillEditor
    }
  }
</script>

<style type="text/scss" lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/main/param.vue